<template>
    <footer>
        <div class="line"></div>
        <div class="top">
            <div class="left">
                <ul class="links" v-for="(link,index) in links" :key="index">
                    <li class="title">
                        <a href="javascript:;" :title="link.title">{{link.title}}</a>
                    </li>
                    <li v-for="(item,index) in link.detail" class="item">
                        <a :href="item.url" :title="item.title">{{item.title}}</a>
                    </li>
                </ul>
            </div>
            <div class="right">
                <a href="/Event/Index" title="活動報名">
                    <i class="icon icon-activity"></i>
                    <span>活動報名</span>
                </a>
                <a href="/Academic/Calendar" title="行事曆">
                    <i class="icon icon-calendar"></i>
                    <span>行事曆</span>
                </a>
                <a href="/Home/ContactUs" title="聯絡我們">
                    <i class="icon icon-mail-1"></i>
                    <span>聯絡我們</span>
                </a>
            </div>
        </div>
        <div class="bottom">
            <a class="logo" href="/">
                <img :src="logo" />
            </a>
            <div class="right">
                <div class="content">
                    <div class="item">地址：台北市中正區常德街一號景福館2樓206室</div>
                    <div class="item">統一編號：31828080</div>
                </div>
                <div class="content">
                    <div class="item">Email：twrs.tw@gmail.com</div>
                    <div class="item">電話：0965-106-869</div>
                    <div class="item">聯繫人：潘柔竹</div>
                </div>
            </div>
        </div>
        <div class="remark">
            <span>©2019 中華民國視網膜醫學會 Taiwan Retina Society , Designed by <a href="https://www.jfetek.com/" target="_blank" rel="noreferrer noopener">Jfetek</a>.</span>
            <span class="none">建議使用 Google Chrome 、 Firefox 等 新型瀏覽器，以利獲得到最佳瀏覽效果</span>
        </div>
    </footer>
</template>

<script>
export default {
    name: "trsfooter",
    components: {},
    props: {},
    data() {
        return {
            logo: require("@/assets/logo-h.png"),
            links: [
                {
                    url: "/News",
                    title: "最新消息",
                    en: "Latest News",
                    root: "News",
                    isPhone: false,
                    detail: [
                        {
                            url: "/News",
                            title: "最新消息"
                        }
                    ]
                },
                {
                    url: "javascript:;",
                    title: "學會簡介",
                    en: "Info",
                    root: "Society",
                    isPhone: true,
                    detail: [
                        {
                            url: "/Society/Index",
                            title: "學會沿革"
                        },
                        {
                            url: "/Society/Chapter",
                            title: "學會章程"
                        },
                        {
                            url: "/Society/Words",
                            title: "理事長的話"
                        },
                        {
                            url: "/Society/Supervisory",
                            title: "理監事名錄"
                        }
                    ]
                },
                {
                    url: "javascript:;",
                    title: "學術活動",
                    en: "Academic",
                    root: "Activity",
                    isPhone: false,
                    detail: [
                        // {
                        //     url: "/Academic/Calendar",
                        //     title: "行事曆"
                        // },
                        {
                            url: "/Academic/Activity",
                            title: "學術活動"
                        },
                        {
                            url: "/Academic/Silhouette",
                            title: "活動花絮"
                        },
                        {
                            url: "/Conference/ActivityProcessList",
                            title: "歷屆活動流程"
                        }
                    ]
                },
                {
                    url: "javascript:;",
                    title: "會刊及影音",
                    en: "Conference",
                    root: "Conference",
                    isPhone: false,
                    detail: [
                        {
                            url: "/Conference/Journals",
                            title: "會刊資訊"
                        },
                        {
                            url: "/Conference/DigitalVideos",
                            title: "影像數位平台"
                        },
                        {
                            url: "/Conference/RelatedInformation",
                            title: "會員專屬資訊"
                        }
                    ]
                },
                {
                    url: "javascript:;",
                    title: "民眾衛教專區",
                    en: "HealthEducation",
                    root: "HealthEducation",
                    isPhone: false,
                    detail: [
                        {
                            url: "/HealthEducation",
                            title: "衛教資訊"
                        },
                        {
                            url: "/HealthEducation/HealthVideos",
                            title: "影片衛教"
                        }
                    ]
                },
                // {
                //   url: "/enroll",
                //   title: "活動報名",
                //   en: "Event",
                //   root: "Event",
                //   isPhone: false
                // },
                {
                    url: "javascript:;",
                    title: "投稿專區",
                    en: "Submission",
                    root: "Submission",
                    isPhone: false,
                    detail: [
                        {
                            url: "/Submission/Index",
                            title: "線上投稿"
                        },
                        {
                            url: "/Submission/Admission",
                            title: "錄取名單"
                        }
                    ]
                },
                {
                    url: "javascript:;",
                    title: "醫病共同決策專區",
                    en: "Medical",
                    root: "Medical",
                    detail: [
                        {
                            url: "/MedicalDecision/Index",
                            title: "醫病共同決策"
                        },
                        {
                            url: "/MedicalDecision/Feedback",
                            title: "醫病決策回饋"
                        }
                    ]
                }
            ]
        };
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
    background-color: #fff;
    line-height: 1.5;
}
footer .line {
    width: 100%;
    background-color: #a59b92;
    height: 2.5px;
    position: relative;
    margin-bottom: 10px;
}
footer .line::after {
    content: "";
    position: absolute;
    top: -4px;
    right: 0;
    left: 0;
    margin: auto;
    width: 100%;
    background-color: #a59b92;
    height: 1px;
}
footer .top,
footer .bottom {
    padding: 10px 15%;
}
footer .top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
}
footer .top .left {
    width: 80%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
footer .top .left .links {
    line-height: 1.5;
    letter-spacing: 2px;
}
footer .top .left .links .title > a {
    color: #ee8b59;
    font-weight: 600;
    margin-bottom: 10px;
}
footer .top .left .links li > a {
    display: block;
    color: #aaa;
    text-decoration: none;
    padding: 3px 0;
}
footer .top .left .links .item:hover a {
    text-decoration: underline;
}
footer .top .right {
    display: flex;
    flex-direction: column;
}
footer .top .right a {
    display: block;
    text-decoration: none;
    color: #ee8b59;
    letter-spacing: 2px;
    line-height: 1.5;
}
footer .top .right a + a {
    padding-top: 15px;
}
footer .top .right a > i {
    padding-right: 5px;
    vertical-align: -5%;
}
footer .bottom {
    display: flex;
    width: 100%;
    margin: auto;
    align-items: center;
    /* justify-content: space-between; */
    background: #eee;
}
footer .bottom .logo {
    display: block;
    width: 200px;
    font-size: 0;
    color: #333;
    text-decoration: none;
}
footer .bottom .logo img {
    width: 100%;
}
footer .bottom .right {
    margin: auto;
}
footer .bottom .title {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0 auto 5px;
}
footer .bottom .title span {
    font-size: 0.9rem;
}
footer .bottom .right .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
footer .bottom .right .content .item {
    padding: 5px 10px;
}
footer .remark {
    background-color: #a59b92;
    padding: 15px 0;
    text-align: center;
    color: #fff;
}
@media screen and (max-width: 1400px) {
    footer .top,
    footer .bottom {
        padding: 10px 10%;
    }
}
@media screen and (max-width: 1200px) {
    footer .top,
    footer .bottom {
        padding: 10px 2.5%;
    }
    footer .top {
        display: none;
    }
    footer .bottom {
        flex-direction: column;
    }
    footer .bottom .logo {
        padding: 10px 0;
    }
    footer .bottom .right .content {
        justify-content: flex-start;
    }
    footer .remark .none {
        display: none;
    }
}
@media screen and (max-width: 768px) {
    footer .bottom .logo {
        height: 70px;
    }
    footer .bottom .right .content {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/footer.vue